import { render, staticRenderFns } from "./ModalPatientClaimOccAuthoCond.vue?vue&type=template&id=2c008772&"
import script from "./ModalPatientClaimOccAuthoCond.vue?vue&type=script&lang=js&"
export * from "./ModalPatientClaimOccAuthoCond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports